// Оболочка, для задания options
import Vue2TouchEvents from 'vue2-touch-events'

export default {
  install: (Vue) => {
    Vue.use(Vue2TouchEvents, {
        disableClick: true,
        touchClass: '',
        tapTolerance: 10,
        touchHoldTolerance: 400,
        swipeTolerance: 50,
        longTapTimeInterval: 400,
    });
  },
};
